/**
 * IMPORTS
 */

import { IdCard, Plus, X } from "lucide-react";

import { Button } from "@components/button/button";

type ICreateActvityModalProps = {
  handleToggleCreateActvityModal: () => void;
};

const CreateLoadModal = ({ handleToggleCreateActvityModal }: ICreateActvityModalProps) => {
  async function handleCreateActvity(event: React.FormEvent<HTMLFormElement>) {
    return event.target;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60">
      <div className="w-[640px] space-y-5 rounded-xl bg-zinc-900 px-6 py-5 shadow-shape">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <h2 className="font-lg font-semibold">Cadastrar nova carga</h2>
            <button>
              <X className="size-5 text-zinc-400" onClick={handleToggleCreateActvityModal} />
            </button>
          </div>

          <p className="text-sm text-zinc-400">
            Preencha todo os dados para cadastrar uma nova carga.
          </p>
        </div>

        <form onSubmit={handleCreateActvity} className="space-y-3">
          <div className="flex h-14 items-center gap-2 rounded-lg border border-zinc-800 bg-zinc-950 px-4">
            <IdCard className="size-5 text-zinc-400" />
            <input
              name="name"
              placeholder="Descrição da carga?"
              className="flex-1 bg-transparent text-lg placeholder-zinc-400 outline-none"
            />
          </div>

          <div className="flex h-14 items-center gap-2 rounded-lg border border-zinc-800 bg-zinc-950 px-4">
            <IdCard className="size-5 text-zinc-400" />
            <input
              name="value"
              placeholder="Valor da carga?"
              className="flex-1 bg-transparent text-lg placeholder-zinc-400 outline-none"
            />
          </div>

          <Button type="submit" className="w-full bg-blue-600">
            <Plus className="size-5" />
            Salvar carga
          </Button>
        </form>
      </div>
    </div>
  );
};

/**
 * EXPORT
 */
export { CreateLoadModal };
